<template>
    <div class="scoreboard-phonetic-vowel">
        <span class="scoreboard-phonetic-vowel__text">{{ currentScore }}/1</span>
        <div class="scoreboard-phonetic-vowel__indicators">
            <span
                v-for="correctness, index in scorelist" :key="index"
                class="scoreboard-phonetic-vowel__indicator"
                :class="[
                    correctness === 1 ? 'scoreboard-phonetic-vowel__indicator--correct'   : '',
                    correctness === 0 ? 'scoreboard-phonetic-vowel__indicator--incorrect' : '',
                ]"></span>
        </div>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            scorelist: { type: Array, default: [-1] },
        },

        computed: {

            currentScore(){
                let currentScore = 0;

                this.scorelist.forEach(correctness => {
                    if(correctness === 1){ currentScore++; }
                });

                return currentScore;
            }
        }
    };
</script>

<style scoped src="@/css/components/scoreboard-phonetic-vowel.css"></style>